import { Builder } from '@builder.io/react'
import React from 'react'

// enum LeftSectionType {
//   Quote = 'quote',
//   TextImage = 'textImage'
// }
interface Props {
  sectionType: string
  text: string
  quoteRichText: string
  backgroundColor: string
  imageOne: string
  imageTwo: string
  textWidth: string
  maxWidth: string
}

const OurStoryHeader = ({
  sectionType,
  backgroundColor,
  text,
  quoteRichText,
  imageOne,
  imageTwo,
  textWidth,
  maxWidth
}: Props) => {
  const getWidth = (width: string) => {
    const addPx = value => (typeof value === 'string' && value.endsWith('px') ? value : `${value}px`)
    if (width) {
      return width ? addPx(width) : '100%'
    }
    return '100%'
  }

  const renderContent = () => {
    if (sectionType === 'quote') {
      return (
        <>
          <img src={imageOne} className="float-left -mt-8 w-8" alt="" />
          <div className="relative mx-auto flex pt-2 text-center font-sans">{text}</div>

          <img src={imageTwo} className="float-right w-8" alt="" />
        </>
      )
    }
    if (sectionType === 'separatedQuote') {
      return (
        <>
          <img src={imageOne} className="float-left -mt-8 w-8" alt="" />
          <div
            className="relative mx-auto flex pt-2 text-center font-sans"
            dangerouslySetInnerHTML={{ __html: quoteRichText }}
          />
          <img src={imageTwo} className="float-right w-8" alt="" />
        </>
      )
    }
    if (sectionType === 'textImage') {
      return (
        <div className="flex flex-row py-2 justify-center items-center">
          <img src={imageOne} className="h-8 w-8" alt="" />
          <div className="relative mx-auto flex text-center">{text}</div>
        </div>
      )
    }
  }

  return (
    <div
      className={`mx-auto w-4/5 rounded-2xl p-4 ${textWidth ? `lg:w-${textWidth}` : 'lg:w-1/2'} max-w-[${getWidth(maxWidth)}]`}
      style={{ backgroundColor }}
    >
      {renderContent()}
    </div>
  )
}

export default OurStoryHeader

Builder.registerComponent(OurStoryHeader, {
  name: 'OurStoryHeader',
  inputs: [
    {
      name: 'sectionType',
      type: 'string',
      enum: ['quote', 'textImage', 'separatedQuote'],
      defaultValue: 'quote'
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'text',
      type: 'string',
      defaultValue: 'Sample Heading'
    },
    {
      name: 'quoteRichText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'imageOne',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageTwo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'textWidth',
      type: 'string',
      enum: ['full', '3/4', '1/2'],
      defaultValue: ''
    },
    {
      name: 'maxWidth',
      type: 'string',
      defaultValue: ''
    }
  ]
})
